// Helpers partilhados para apresentar o histórico de Ordens de Serviço
// (OrdemServicoHistorico + OrdemServicoEmailEvento, unificados pelo endpoint
// /api/v1/ordemservico/historico/pagination/). Usado pela página "Histórico OS"
// (views/Ordem_Servico/OrdemServicoHistoricoView.vue) e pelo popup de
// notificações de uma OS (components/dialog/notificacaoes_agendamentos.vue).

export const EVENTO_LABELS = {
  CREATE: "Criada",
  UPDATE: "Atualizada",
  DELETE: "Eliminada",
  enviado: "Email enviado",
  reenviado: "Email reenviado",
  aberto: "Email aberto pelo cliente",
  confirmado: "Confirmado pelo cliente",
  adiado: "Adiamento pedido pelo cliente",
  confirmado_admin: "Confirmado manualmente (utilizador interno)",
  aprovado_admin: "Adiamento aprovado por administrador",
  rejeitado_admin: "Adiamento rejeitado por administrador",
  cancelado_admin: "Cancelado por administrador",
};

// Eventos que representam uma decisão final sobre o agendamento (usados para
// destacar o desfecho no topo do popup de notificações).
export const EVENTOS_DECISIVOS = [
  "confirmado",
  "adiado",
  "confirmado_admin",
  "aprovado_admin",
  "rejeitado_admin",
  "cancelado_admin",
];

export function getEventoLabel(row) {
  return row?.evento_label || EVENTO_LABELS[row?.evento] || row?.evento || "N/A";
}

export function getEventoClass(evento) {
  const key = (evento || "").toUpperCase();
  if (["CREATE", "ENVIADO", "REENVIADO", "CONFIRMADO", "CONFIRMADO_ADMIN", "APROVADO_ADMIN"].includes(key)) {
    return "bg-emerald-500/20 text-emerald-400";
  }
  if (["UPDATE", "ABERTO"].includes(key)) {
    return "bg-blue-500/20 text-blue-400";
  }
  if (["DELETE", "ADIADO", "REJEITADO_ADMIN", "CANCELADO_ADMIN"].includes(key)) {
    return "bg-red-500/20 text-red-400";
  }
  return "bg-gray-500/20 text-gray-400";
}

export function formatDateTime(value) {
  if (!value) return "N/A";
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) return "N/A";
    return date.toLocaleString("pt-PT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "N/A";
  }
}

// Interpreta o JSON livre guardado em `detalhes` (delay_reason, novas datas,
// motivo de cancelamento, notas do admin, assunto do email) num array de
// { label, value } prontos a apresentar.
export function parseDetalhes(detalhesJson) {
  if (!detalhesJson) return [];
  let dados;
  try {
    dados = JSON.parse(detalhesJson);
  } catch {
    return [];
  }

  const partes = [];
  if (dados.delay_reason) partes.push({ label: "Motivo", value: dados.delay_reason });
  if (dados.new_data_inicio) partes.push({ label: "Nova data início", value: formatDateTime(dados.new_data_inicio) });
  if (dados.new_data_fim) partes.push({ label: "Nova data fim", value: formatDateTime(dados.new_data_fim) });
  if (dados.subject) partes.push({ label: "Assunto", value: dados.subject });
  if (dados.motivo_cancelamento) partes.push({ label: "Motivo do cancelamento", value: dados.motivo_cancelamento });
  if (dados.admin_notes) partes.push({ label: "Notas", value: dados.admin_notes });
  // Só existe em eventos reconstruídos (não gravados) de OS anteriores a esta
  // funcionalidade, quando não há utilizador_id guardado para o autor.
  if (dados.cancelado_por_nome_historico) partes.push({ label: "Cancelado por", value: dados.cancelado_por_nome_historico });
  return partes;
}
